import { Loader } from '@mantine/core'
import { useRouter } from 'next/router'

import { DocumentContractPreview } from '../components/DocumentContractPreview/DocumentContractPreview'

export function PageDocumentContract() {
  const router = useRouter()
  const bookingId = router.query.id as string

  if (!bookingId) {
    return <Loader />
  }

  return <DocumentContractPreview />
}
